export default __webpack_public_path__ + "static/media/events_selected.2099d165.webp";